<div [ngClass]="{'divbox': isDialog}" fxLayoutAlign="center center">
    <mat-card class="box">
      <div >
  
        <div class="divtitle">
          <mat-card-title class="clstitle">
            <div class="title-grid">
              <div *ngIf="alarmConfiguration.parent_type == 'C'">
                {{'alarmConfiguration.titleGlobal' | transloco}}
              </div>
              <div *ngIf="alarmConfiguration.parent_type == 'W'">
                {{'alarmConfiguration.titleWorker' | transloco}}
              </div>
            </div>
          </mat-card-title>
        </div>
  
        <div>
          <form method="post" class="form" #f="ngForm" (ngSubmit)="f.form.valid && onGuardarItm()" >
            <mat-card-content class="mat-elevation-z8"> 

              <mat-form-field *ngIf="storageService.roleId==1 && alarmConfiguration.parent_type == 'C'" class="full-width">
                <mat-label>{{ 'alarmConfiguration.selectCompany' | transloco }}</mat-label>
                <mat-select (selectionChange)="onCompanySelected($event.value)">
                  <mat-option *ngFor="let item of companys" [value]="item">
                    {{ item.id }}: {{ item.name }} - {{ item.country }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="full-width">
                <mat-label>{{ 'alarmConfiguration.workDays' | transloco }}</mat-label>
                <mat-select multiple [(ngModel)]="selectedWorkDays" name="workDays" [disabled]="!alarmConfiguration.parent_id">
                  <mat-option *ngFor="let day of weekDays" [value]="day.codigo">
                    {{ day.descripcion }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <div style="display: flex;">
                <mat-form-field class="full-width">
                  <mat-label>{{ 'alarmConfiguration.timeFrom' | transloco }}</mat-label>
                  <input matInput type="time" [(ngModel)]="timeFrom" name="timeFrom" [disabled]="!alarmConfiguration.parent_id">
                </mat-form-field>
  
                <mat-form-field class="full-width">
                  <mat-label>{{ 'alarmConfiguration.timeTo' | transloco }}</mat-label>
                  <input matInput type="time" [(ngModel)]="timeTo" name="timeTo" [disabled]="!alarmConfiguration.parent_id">
                </mat-form-field>
              </div>
              <div style="display: flex;">
                <mat-form-field class="full-width">
                  <mat-label>{{ 'alarmConfiguration.timeFrom' | transloco }}</mat-label>
                  <input matInput type="time" [(ngModel)]="timeFrom2" name="timeFrom2" [disabled]="!alarmConfiguration.parent_id">
                </mat-form-field>
  
                <mat-form-field class="full-width">
                  <mat-label>{{ 'alarmConfiguration.timeTo' | transloco }}</mat-label>
                  <input matInput type="time" [(ngModel)]="timeTo2" name="timeTo2" [disabled]="!alarmConfiguration.parent_id">
                </mat-form-field>
              </div>
              <div *ngIf="!isTimeRangeValid()" class="error">
                El tiempo de inicio debe ser anterior al tiempo de fin.
              </div>                
              
              <mat-form-field class="full-width">
                <mat-label>{{ 'alarmConfiguration.retentionTime' | transloco }}</mat-label>
                <mat-select [(ngModel)]="alarmConfiguration.retention_time" name="retentionTime" [disabled]="!alarmConfiguration.parent_id">
                  <mat-option [value]="1">
                    {{ 'alarmConfiguration.1min' | transloco }}
                  </mat-option>
                  <mat-option [value]="2">
                    {{ 'alarmConfiguration.2min' | transloco }}
                  </mat-option>
                  <mat-option [value]="5">
                    {{ 'alarmConfiguration.5min' | transloco }}
                  </mat-option>
                  <mat-option [value]="10">
                    {{ 'alarmConfiguration.10min' | transloco }}
                  </mat-option>
                  <mat-option [value]="15">
                    {{ 'alarmConfiguration.15min' | transloco }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-card-content>
  
            <div style="margin-top: 20px;">
              <div class="button-row">
                <div fxLayoutAlign="end">
                  <button mat-raised-button color="primary" type="submit" [disabled]="!alarmConfiguration.parent_id || !isTimeRangeValid()">{{'alarmConfiguration.save' | transloco}}</button>
                  <button *ngIf="isDialog" mat-raised-button color="basic" [mat-dialog-close]="false">{{'alarmConfiguration.cancel' | transloco}}</button>
                  <button *ngIf="alarmConfiguration.parent_type == 'W'" type="button" mat-raised-button color="basic" (click)="deleteWorkerConfig()">{{'alarmConfiguration.deleteWorkerAlarm' | transloco}}</button>
                </div>
              </div>
            </div>
          </form>
        </div>
  
    </div>
    </mat-card>
  </div>
  
  
  